module.exports = __webpack_public_path__ + "static/img/image039.16389a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image039.png
// module id = +8Q4
// module chunks = 1